module.exports = __webpack_public_path__ + "img/businessTag.2b60339a.png";